import React from 'react'

const TextLabel = ({text, required = false, className = ''}) => {
  return (
    <p className={'text-sm font-semibold ' + className} >{text} {required && <span className='text-red-500'>*</span>} </p>
  )
}

export default TextLabel